import React, { useMemo } from 'react';
import { VerifyIdentity } from './steps/VerifyIdentity';
import { ConfirmOTP } from './steps/ConfirmOTP';
import { SelectBillsAndPay } from './steps/SelectBillsAndPay';
import { Confirmation } from './steps/Confirmation';
import { Stepper } from '@shared/components/Stepper';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { GuestPortalTopnav } from '../../Topnav';
import { AnnouncementBanner } from '../../AnnouncementBanner';
import { useTranslation } from 'react-i18next';

export const PayBillsLanding = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const steps = useMemo(() => [
    {
      id: 1,
      title: t("Verify Identity"),
      slug: 'verify-identity',
      component: <VerifyIdentity />
    },
    {
      id: 2,
      title: t("Confirm OTP"),
      slug: 'confirm-otp',
      component: <ConfirmOTP />
    },
    {
      id: 3,
      title: t("Select Bills & Pay"),
      slug: 'select-bills',
      component: <SelectBillsAndPay />
    },
    {
      id: 4,
      title: t("Confirmation"),
      slug: 'confirmation',
      component: <Confirmation />
    }
  ], [t]);

  return (
        <div className="h-screen flex flex-col  overflow-hidden">
          <GuestPortalTopnav />
          
          {/* Banner */}
        <AnnouncementBanner />
      
      {/* Container */}
      
      <div className="flex-1 overflow-y-auto w-full pt-4">

        {/* Main Title */}
        <div className="mb-8 px-4">
          <h1 className="text-2xl font-bold text-gray-900 ">{t("Bill Payment")}</h1>
          <p className="text-gray-500">{t("Verify your account and pay your utility bills securely.")}</p>
        </div>

        {/* Shared Stepper */}
        <Stepper
          steps={steps}
          enableRouting={true}
          storageKey="guest-pay-bills-stepper"
          autoSave={false}
          persistProgress={false}
          allowStepClick={false}
        />
        
      </div>
    </div>
  );
};
